import * as React from 'react';
import { Component } from '../../../infrastructure/type-extensions';
import { CommonPopoverContext } from './common-popover.context';

interface IPopoverButtonProps {
    onClick(): void;
}

/**
 * Concrete skin for close button shall receive clickHandler as a prop.
 * onClick function, received as a prop of built close button, return boolean (or Promise<boolean>)
 * if true/undefined - close popover. if false - do not close.
 * if Promise - await promise completion before closing popover
 *
 * @param CloseButtonPresentation
 */
function createClosePopoverButton<T>(
    CloseButtonPresentation: Component<T & IPopoverButtonProps>,
) {
    return (props: T & { onClick?: () => Promise<boolean> | boolean | void}) => (
        <CommonPopoverContext.Consumer>
            {context => {
                // if onClick passed
                const clickHandlerHOCClosingSubWindow = props.onClick ? () => {
                    const actionResult = props.onClick();
                    // if return promise - wait until it is ended
                    if (actionResult instanceof Promise) {
                        // then close popover only if it has ended successfully returning 'true'
                        actionResult.then((result: boolean) => result && context.closePopover());
                    } else {
                        // if return plain boolean - close popover if this boolean is true
                        // if does not return anything - consider as succes and also close popover
                        if (actionResult || actionResult === undefined) {
                            context.closePopover();
                        }
                    }
                } : context.closePopover;

                return (<CloseButtonPresentation { ...props} onClick={clickHandlerHOCClosingSubWindow} />);
            }}
        </CommonPopoverContext.Consumer>
    );
}

export { createClosePopoverButton };
